import type { RootState } from 'store'
import { getCurrentStepIndex } from 'store/tutorial'
import itemsList from './mock/itemsList.json'

export const selectRetailWinesState = (state: RootState) => {
  const tutorialStep = getCurrentStepIndex(state)
  const isTutrialActive = tutorialStep !== null
  if (isTutrialActive) {
    return {
      items: itemsList,
      refetchTrigger: 0,
      pageInfo: {
        __typename: 'PageInfo',
        totalItems: 1213,
        totalPages: 49,
        page: 1,
        perPage: 25,
        hasNextPage: true,
        hasPreviousPage: false,
      },
      sorting: state?.retailWines?.sorting || {
        type: null,
        name: null,
        value: null,
      },
      loading: false,
      error: null,
      query: '',
      filters: [],
      selectedItems: [],
      currency: {
        __typename: 'Currency',
        code: 'EUR',
        id: 1,
      },
    }
  }
  return state?.retailWines
}

export const getSort = (state: RootState) =>
  selectRetailWinesState(state)?.sorting
export const getPageInfo = (state: RootState) =>
  selectRetailWinesState(state)?.pageInfo ?? null
export const getLoading = (state: RootState) =>
  selectRetailWinesState(state)?.loading
export const getError = (state: RootState) =>
  selectRetailWinesState(state)?.error
export const getItems = (state: RootState) =>
  selectRetailWinesState(state)?.items
export const getQuery = (state: RootState) =>
  selectRetailWinesState(state)?.query ?? ''
export const getFilters = (state: RootState) =>
  selectRetailWinesState(state)?.filters ?? []
export const getSelectedItems = (state: RootState) =>
  selectRetailWinesState(state)?.selectedItems || []
export const getCurrency = (state: RootState) =>
  selectRetailWinesState(state)?.currency ?? null
export const getRefetchTrigger = (state: RootState) =>
  selectRetailWinesState(state)?.refetchTrigger ?? 0
export const getWineLotBottleQuantity = (state: RootState) =>
  state?.retailWines?.wineLotBottleQuantity
export const getDeliveryCostCode = (state: RootState) =>
  state?.retailWines?.deliveryCostCode
export const getVatBehaviorCode = (state: RootState) =>
  state?.retailWines?.vatBehaviorCode
export const getPurchaseConditionCode = (state: RootState) =>
  state?.retailWines?.purchaseConditionCode
export const getSelectorsInitialized = (state: RootState) =>
  state?.retailWines?.selectorsInitialized ?? false
